module.exports = __webpack_public_path__ + "img/BANNER_REVISTA_MOVIL-01.70ed0997.jpg";